import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';
import {
  fetchTranslationsSuccess,
  fetchTranslationsFailure,
  fetchSupportedLanguagesSuccess,
  fetchSupportedLanguagesFailure,
} from './language-provider-actions';

export function* fetchTranslations(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `translations/${action.payload}`,
      options: {
        errorMessage: 'Could not fetch translations',
        retryAction: action,
      },
    });
    yield put(fetchTranslationsSuccess(results));
  } catch (err) {
    yield put(fetchTranslationsFailure(err));
  }
}

export function* fetchSupportedLanguages(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'translations/languageDefinitions',
      options: {
        errorMessage: 'Could not fetch supported languages',
        retryAction: action,
      },
    });
    yield put(fetchSupportedLanguagesSuccess(results));
  } catch (err) {
    yield put(fetchSupportedLanguagesFailure(err));
  }
}

function* watchFetchTranslations() {
  yield takeLatest(actionTypes.FETCH_TRANSLATIONS_REQUEST, fetchTranslations);
}

function* watchFetchSupportedLanguages() {
  yield takeLatest(actionTypes.FETCH_SUPPORTED_LANGUAGES_REQUEST, fetchSupportedLanguages);
}

export default [fork(watchFetchTranslations), fork(watchFetchSupportedLanguages)];
